export const setRegion = (state = [], action) => {
    switch (action.type) {
        case "SET_REGION":
            return action.payload;
        default:
            return state;
    }
}